import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	StopServiceDTO,
	StopServiceRequest,
	StopServiceSaveDTO,
} from '../DTO/forms-management/stopService';

export const stopService = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getStopServiceList: builder.query<
			SuccessResponse<StopServiceDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/form/consent-service-termination/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['StopServiceList'],
		}),
		deleteStopService: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/consent-service-termination/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['StopServiceList'],
		}),
		stopServiceHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/consent-service-termination/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getStopServiceDraft: builder.query<
			SuccessResponse<StopServiceSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/consent-service-termination/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueStopServiceDraft: builder.mutation<
			SuccessResponse<StopServiceSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/consent-service-termination/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editStopService: builder.mutation<SuccessResponse<any>, StopServiceRequest>(
			{
				query: (body) => ({
					url: `/web/form/consent-service-termination/${body.id}`,
					method: 'PUT',
					body,
				}),
			}
		),
		createStopService: builder.mutation<
			SuccessResponse<any>,
			StopServiceRequest
		>({
			query: (body) => ({
				url: `/web/form/consent-service-termination`,
				method: 'POST',
				body,
			}),
		}),
		getStopServiceDetail: builder.query<
			SuccessResponse<StopServiceDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/form/consent-service-termination/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetStopServiceListQuery,
	useDeleteStopServiceMutation,
	useStopServiceHasDraftQuery,
	useGetStopServiceDraftQuery,
	useContinueStopServiceDraftMutation,
	useEditStopServiceMutation,
	useCreateStopServiceMutation,
	useGetStopServiceDetailQuery,
} = stopService;
